import { Action } from '@ngrx/store';
import {
  FormattedOfferData,
  FormattedPaginatedOfferData,
  HttpError,
  OfferPaginationOptions,
  OfferQueryParams,
  OfferSource,
} from '@rd/types';

export enum OfferActionTypes {
  LOAD_OFFERS = '[Offer] Load Offers',
  LOAD_PAGINATED_OFFERS = '[Offer] Load Paginated Offers',
  LOAD_MORE_OFFERS = '[Offer] Load More Offers',
  LOAD_OFFERS_SUCCESS = '[Offer] Load Offers Success',
  LOAD_MORE_OFFERS_SUCCESS = '[Offer] Load More Offers Success',
  LOAD_OFFERS_FAIL = '[Offer] Load Offers Fail',
  LOAD_MORE_OFFERS_FAIL = '[Offer] Load More Offers Fail',
  VIEW_OFFER_DETAILS = '[Offer] View Offers Details',
  LOAD_SINGLE_OFFER = '[Offer] Load Offer',
  LOAD_SINGLE_OFFER_SUCCESS = '[Offer] Load Single Offer Success',
  LOAD_SINGLE_OFFER_FAIL = '[Offer] Load Single Offer Fail',
  RESET_OFFER_LIST = '[Offer] Reset Offer List',
  LOAD_BNZ_HOMEPAGE_OFFERS = '[Offer] Load BNZ Homepage Offers',
}

export class LoadOffers implements Action {
  readonly type = OfferActionTypes.LOAD_OFFERS;

  constructor(
    public payload: {
      queryParams: OfferQueryParams;
      shouldShowLoadingState?: boolean;
    },
  ) {}
}

export class LoadPaginatedOffers implements Action {
  readonly type = OfferActionTypes.LOAD_PAGINATED_OFFERS;

  constructor(
    public payload: {
      queryParams: OfferQueryParams;
      paginationOptions: OfferPaginationOptions;
    },
  ) {}
}

export class LoadMoreOffers implements Action {
  readonly type = OfferActionTypes.LOAD_MORE_OFFERS;

  constructor(
    public payload: {
      queryParams: OfferQueryParams;
      shouldShowLoadingState?: boolean;
    },
  ) {}
}

export class LoadOffersSuccess implements Action {
  readonly type = OfferActionTypes.LOAD_OFFERS_SUCCESS;

  constructor(
    public payload: FormattedPaginatedOfferData & { source?: OfferSource },
  ) {}
}

export class LoaMoredOffersSuccess implements Action {
  readonly type = OfferActionTypes.LOAD_MORE_OFFERS_SUCCESS;

  constructor(
    public payload: FormattedPaginatedOfferData & { source?: OfferSource },
  ) {}
}

export class LoadOffersFail implements Action {
  readonly type = OfferActionTypes.LOAD_OFFERS_FAIL;

  constructor(public payload: HttpError, public source?: OfferSource) {}
}

export class LoadMoreOffersFail implements Action {
  readonly type = OfferActionTypes.LOAD_MORE_OFFERS_FAIL;

  constructor(public payload: HttpError, public source?: OfferSource) {}
}

export class ViewOfferDetails implements Action {
  readonly type = OfferActionTypes.VIEW_OFFER_DETAILS;

  constructor(public payload: string) {}
}

export class LoadSingleOffer implements Action {
  readonly type = OfferActionTypes.LOAD_SINGLE_OFFER;

  constructor(public payload: string) {}
}

export class LoadOfferSuccess implements Action {
  readonly type = OfferActionTypes.LOAD_SINGLE_OFFER_SUCCESS;

  constructor(public payload: FormattedOfferData['offerMap']) {}
}

export class LoadOfferFail implements Action {
  readonly type = OfferActionTypes.LOAD_SINGLE_OFFER_FAIL;

  constructor(public payload: HttpError) {}
}

export class ResetOfferList implements Action {
  readonly type = OfferActionTypes.RESET_OFFER_LIST;
}

export class LoadBnzHomepageOffers implements Action {
  readonly type = OfferActionTypes.LOAD_BNZ_HOMEPAGE_OFFERS;

  constructor(
    public payload: { isVoxEnabled: boolean } = { isVoxEnabled: false },
  ) {}
}

export type OfferActions =
  | LoadOffers
  | LoadPaginatedOffers
  | LoadMoreOffers
  | LoadOffersSuccess
  | LoaMoredOffersSuccess
  | LoadOffersFail
  | LoadMoreOffersFail
  | ViewOfferDetails
  | LoadSingleOffer
  | LoadOfferSuccess
  | LoadOfferFail
  | ResetOfferList
  | LoadBnzHomepageOffers;
